import { useEffect, useState } from "react";
import "./index.scss";
import { LeaderboardBrand, LeaderboardProps } from "../Leaderboard";
import { Coin } from "../../shared/coin/Coin";

export interface LeaderboardResultsProps extends LeaderboardProps {
  ended?: boolean;
  timestamp: string;
}
export const LeaderboardResults = (props: LeaderboardResultsProps) => {
  const [data, setData] = useState<Record<string, any>[]>([]);

  useEffect(() => {
    import(
      `/src/leaderboard/results/data/${props.brand}/${props.month}.json`
    ).then((module) => {
      setData(
        module.default.data.affiliateEarningsByReferee.edges
          .filter((n: any) => !n.node.statuses.includes("STOLEN"))
          .filter((n: any) => n.node.commission > 0)
          .filter((n: any) => n.node.wageredTotal >= 1),
      );
    });
  }, [props.brand, props.month]);

  const whitelist = (value: string) => {
    const maps: Record<string, string> = {
      "D O*P E": "D * * E",
      "\ud835****\udc52": "a*e",
    };
    if (maps[value]) return maps[value];
    return value;
  };

  const filler = {
    name: "Empty",
    hiddenName: "Empty",
    amount: "0",
  };

  if (!data) {
    return <p>Loading...</p>;
  }

  const results = data.map((n, i) => ({
    name: n.node.referee.name,
    hiddenName: n.node.referee.hiddenName,
    amount: n.node.wageredTotal.toFixed(0),
    position: i + 1,
  }));

  console.log(results);
  if (!data && results.length < 1) {
    for (let i = results.length + 1; i <= 20; i++) {
      results.push({
        ...filler,
        position: i,
      });
    }
  }

  const prizesMap = {
    1: 4000,
    2: 2000,
    3: 1250,
    4: 750,
    5: 500,
    6: 400,
    7: 350,
    8: 250,
    9: 200,
    10: 100,
    11: 25,
    12: 25,
    13: 25,
    14: 25,
    15: 25,
    16: 25,
    17: 25,
    18: 25,
    19: 25,
    20: 25,
  };

  const obscureName = (name: string) => {
    // This function is used to hide inner characters of the name
    // and only show first 20% and last 20% of the name.
    const len = name.length;
    if (len <= 5) return name;
    const start = Math.floor(len * 0.4);
    const end = Math.ceil(len * 0.6);
    const obscured = name.slice(start, end).replace(/./g, "*");
    return name.slice(0, start) + obscured + name.slice(end);
  };

  const names = results.map((result) => obscureName(result.name));

  return (
    <div className="results">
      <p>
        {props.ended ? "Ended at" : "Updated for"} {props.timestamp}
      </p>
      <p>
        <i>It may take up to 24 hours for data to be displayed properly.</i>
      </p>
      <div className="container">
        <div className="positions">
          <span> Position </span>
          {results.map((result, i) => (
            <span key={result.position} className={"position" + i}>
              {result.position === 1 && "🥇"}
              {result.position === 2 && "🥈"}
              {result.position === 3 && "🥉"}
              {result.position}
            </span>
          ))}
        </div>
        <div className="names">
          <span> Name </span>
          {names.map((name, i) => (
            <span key={name} className={"names" + i}>
              {whitelist(name)}
            </span>
          ))}
        </div>

        <div className="reward">
          <span> Wagered </span>
          {results.map((result, i) => {
            const reward = "🎫";
            const tickets = result.amount;
            return (
              <span key={result.position} className={"reward" + i}>
                {tickets}
                {reward}
              </span>
            );
          })}
        </div>

        <div className="prize">
          <span>Prize</span>
          {Object.entries(prizesMap).map(([position, prize], i) => (
            <div>
              <span key={position} className={"prize-item prize" + i}>
                {prize} <Coin brand={LeaderboardBrand.CSGOROLL} />
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
